import store from '../store';

export default function (to, from, next) {

    if (store.getters.isLogin) {
        next({name: 'diary'})
    } else {
        next()
    }
}
